import React from "react";
import { connect } from "react-redux";
import { Row, Col, Card, Avatar, Popover, Form, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { SendOutlined, LoadingOutlined } from "@ant-design/icons";
import scrollIntoView from "scroll-into-view-if-needed";
import { chatcount } from "store/slice/patient-detail-slice";
import "./VideoConsultationChatChild.scss";
import { Client as ConversationsClient } from "@twilio/conversations";
import utils from "utils";
import Loader from "Components/Loader";
import icons from "Common/Icons";
import { notification } from "antd";
import MultiMediaMessage from "Components/MultiMediaMessage";
import LinkMessage from "Components/LinkMessage";
import { SUPPORTED_IMG_FILES } from "Common/constant";
import { SUPPORTED_DOC_FILES } from "Common/constant";
import { IconTeleCall } from "Common/ReactIcons";

const key = "updatable";

class VideoConsultationConversation extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      messages: [],
      loading: false,
      sendingFile: false,
      identity: "",
      roomName: "",
      token: "",
      conversation: null,
      rmtPrtcptAdded: false,
    };
    this.messagesEndRef = React.createRef();
    this.reply_form = React.createRef();
  }

  scrollToMessageBottom() {
    if (
      document.getElementById(
        `message-list-item-${this.state.messages?.length - 1}`
      )
    )
      scrollIntoView(
        document.getElementById(
          `message-list-item-${this.state.messages?.length - 1}`
        ),
        {
          behavior: "instant",
          scrollMode: "if-needed",
          boundary: document.getElementById("message-container"),
        }
      );
  }

  loadMessagesFor = (thisConversation) => {
    thisConversation
      .getMessages()
      .then((messagePaginator) => {
        this.setState({
          messages: messagePaginator.items,
          loading: false,
        });
        this.scrollToMessageBottom();
      })
      .catch((err) => {
        console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
        console.log(err);
        this.setState({ loading: false });
      });
  };

  handleConvoJoin(conversationsClient) {
    // this.conversationsClient.on("conversationJoined", (conversation) => {
    //   if (conversation?.uniqueName == convo_name) {
    //     this.loadMessagesFor(conversation);
    //   }
    // });

    const convo_name =
      this.props.roomName.toString() + this.props.appointment_utc_date_time;
    conversationsClient
      .getConversationByUniqueName(convo_name)
      .then((convo) => {
        convo
          .getParticipants()
          .then((participants) => {
            let part_twilio_id = this.props.rmt_prtcp_id.toString();
            let rmtPrtcpData = participants.filter(
              (participant) => participant?.state?.identity == part_twilio_id
            );
            if (rmtPrtcpData.length == 0) {
              convo
                .add(part_twilio_id)
                .then((participants) => {
                  this.setState({ rmtPrtcptAdded: true });
                  this.props.publishDataTrack();
                })
                .catch((error) => {
                  console.log("Participant Add Error");
                  console.log(error);
                });
            } else {
              this.setState({ rmtPrtcptAdded: true });
            }
          })
          .catch((error) => {
            console.log(error);
          });

        this.setState({ loading: true });
        this.loadMessagesFor(convo);
        this.setState({ conversation: convo });
      })
      .catch((err) => {
        conversationsClient
          .createConversation({
            uniqueName: convo_name,
            friendlyName: convo_name,
          })
          .then((convo) => {
            convo.join().then((res) => {
              let part_twilio_id = this.props.rmt_prtcp_id.toString();
              convo
                .add(part_twilio_id)
                .then((participants) => {
                  this.setState({ rmtPrtcptAdded: true });
                  this.props.publishDataTrack();
                })
                .catch((error) => {
                  console.log("Participant Add Error");
                  console.log(error);
                });
              this.setState({ conversation: res });
            });
          })
          .catch((err) => {
            console.log("Error in conversation create");
            console.log(err);
          });
      });

    // this.conversationsClient.on("conversationLeft", (thisConversation) => {
    //   console.log(thisConversation);
    // });
  }

  initConversation = async () => {
    this.conversationsClient = new ConversationsClient(this.props.token);

    this.conversationsClient.on("initialized", () => {
      this.handleConvoJoin(this.conversationsClient);
    });

    this.conversationsClient.on("messageAdded", (m) => this.addMessages(m));

    this.conversationsClient.on("initFailed", ({ error }) => {
      console.log("Convo Init Failed", error);
    });

    // this.conversationsClient.on("connectionStateChanged", (state) => {
    //   if (state === "connecting")
    //     this.setState({
    //       statusString: "Connecting to Twilio…",
    //       status: "default",
    //     });
    //   if (state === "connected") {
    //     this.setState({
    //       statusString: "You are connected.",
    //       status: "success",
    //     });
    //   }
    //   if (state === "disconnecting")
    //     this.setState({
    //       statusString: "Disconnecting from Twilio…",
    //       conversationsReady: false,
    //       status: "default",
    //     });
    //   if (state === "disconnected")
    //     this.setState({
    //       statusString: "Disconnected.",
    //       conversationsReady: false,
    //       status: "warning",
    //     });
    //   if (state === "denied")
    //     this.setState({
    //       statusString: "Failed to connect.",
    //       conversationsReady: false,
    //       status: "error",
    //     });
    // });
  };

  replyMessage = (values) => {
    this.setState({ text: values.replyMsg }, () => {
      this.sendMessage();
      this.reply_form.current.resetFields();
      notification.destroy();
    });
  };

  checkAndAddRmtPrtcpt() {
    if (this.state.conversation) {
      this.setState({ loading: true });

      setTimeout(() => {
        this.state.conversation
          .getParticipants()
          .then((participants) => {
            let part_twilio_id = this.props.rmt_prtcp_id.toString();
            let rmtPrtcpData = participants.filter(
              (participant) => participant?.state?.identity == part_twilio_id
            );

            if (rmtPrtcpData.length == 0) {
              this.state.conversation
                .add(part_twilio_id)
                .then((participants) => {
                  this.setState({ loading: false, rmtPrtcptAdded: true });
                  this.props.publishDataTrack();
                })
                .catch((error) => {
                  console.log("Participant Add Error After Join");
                  console.log(error);
                  this.setState({ loading: false });
                });
            } else {
              this.setState({ loading: false });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }, 5000);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isRmtPrtcptJoined !== prevProps.isRmtPrtcptJoined) {
      this.checkAndAddRmtPrtcpt();
    }
    if (this.props.reloadRmtPrtcptConvo !== prevProps.reloadRmtPrtcptConvo) {
      this.handleConvoJoin(this.conversationsClient);
    }
  }

  componentDidMount() {
    this.initConversation();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.conversationsClient.shutdown();
  }

  addMessages = (message) => {
    const { messages } = this.state;
    let msg =
      Array.isArray(message) && message.length
        ? message
        : !Array.isArray(message) && typeof message == "object"
        ? [message]
        : [];
    this.setState(
      {
        messages: [...messages, ...msg],
      },
      () => {
        if (this.state.messages?.length > 0)
          this.props.chatcount(this.state.messages?.length);
        this.scrollToMessageBottom();
      }
    );

    if (
      this.props.showChat &&
      message.author != this.props.identity.toString()
    ) {
      notification.open({
        key,
        message: (
          <Row className="chat-notification" justify="space-between">
            <Col>Chat</Col>
            <Col>
              <img
                className="video-consultation-server-icon"
                src={icons.new_video_consultation_service}
              />
            </Col>
          </Row>
        ),
        description: (
          <>
            <div className="chat-footer">
              <Row>
                <Col span={24} className="gutter-row">
                  <div className="Cui-box receiver">
                    <Avatar size="default" className="receiver-avatar">
                      {this.props.remoteUserName.charAt(0)}
                    </Avatar>
                    <div className="Cui-message">
                      <div>
                        <span>{message.body}</span>
                      </div>
                      <div className="msg-time">
                        <span>
                          {utils.FormatDate(message.dateCreated, "TIME_1")}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="gutter-row" span={24}>
                  <Form ref={this.reply_form} onFinish={this.replyMessage}>
                    <Form.Item
                      label=""
                      name="replyMsg"
                      rules={[
                        {
                          required: true,
                          message: "Enter a message to send",
                        },
                      ]}
                    >
                      <Input.Search
                        placeholder="Write a message"
                        onPressEnter={() => this.reply_form.current.submit()}
                        enterButton={<SendOutlined />}
                        onSearch={() => this.reply_form.current.submit()}
                        style={{
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </div>
          </>
        ),
        duration: 300,
      });
    }
  };

  isURLMsg(str) {
    let matchedStr = str.match(/\bhttps?:\/\/\S+/gi);
    if (matchedStr) {
      return true;
    } else {
      return false;
    }
  }

  sendMultiMediaFile(file) {
    this.setState({ sendingFile: true });
    const { conversation } = this.state;
    const formData = new FormData();
    formData.append("file", file);
    conversation
      .sendMessage(formData)
      .then((res) => {
        this.setState({ sendingFile: false });
      })
      .catch((error) => {
        this.setState({ sendingFile: false });
        console.log(error);
      });
  }

  sendMessage = () => {
    const { text, conversation } = this.state;
    let trimdTxt = text.trim();
    if (trimdTxt) {
      // this.setState({ loading: true });
      if (this.isURLMsg(trimdTxt)) {
        conversation.sendMessage(trimdTxt, { isLink: true });
      } else {
        conversation.sendMessage(trimdTxt);
      }
      // this.setState({ text: "", loading: false });
      this.setState({ text: "" });
    }
    // this.scrollToBottom();
  };

  scrollToBottom = () => {
    this.messagesEndRef.current?.scrollIntoView();
  };
  render() {
    const { loading, text, messages, conversation } = this.state;
    return (
      <div className="VCC">
        <Row gutter={24}>
          <Col className="gutter-row" span={24}>
            <Card
              type="inner"
              title={
                <>
                  <div className="align-center">
                    Chat
                    {/* <CloseOutlined onClick={() => this.props.toggleChat()} /> */}
                  </div>
                  <Popover
                    placement="leftTop"
                    title="24/7 Support"
                    content="In case of emergency, please contact Care Admin: +91 93******64"
                  >
                    {/* <img
                      className="video-consultation-server-icon"
                      src={icons.new_video_consultation_service}
                    /> */}
                    <IconTeleCall/>
                  </Popover>
                </>
              }
              actions={[
                <Row>
                  <Col className="gutter-row" span={22} offset={1}>
                    <div className="chat-footer">
                      <Input.Search
                        placeholder="Write a message"
                        suffix={
                          <Upload
                            fileList={[]}
                            beforeUpload={(file) => {
                              if (
                                SUPPORTED_DOC_FILES.includes(file.type) ||
                                SUPPORTED_IMG_FILES.includes(file.type)
                              ) {
                                this.sendMultiMediaFile(file);
                              } else {
                                message.error(
                                  "Invalid file type. Supports only PNG or JPEG or PDF file.", ErrorDuration
                                );
                              }
                              return false;
                            }}
                          >
                            <UploadOutlined
                              style={{
                                fontSize: 16,
                                color: "#667085",
                              }}
                            />
                          </Upload>
                        }
                        value={text}
                        onChange={(event) =>
                          this.setState({ text: event.target.value })
                        }
                        disabled={
                          !conversation ||
                          this.state.loading ||
                          this.state.sendingFile ||
                          !this.state.rmtPrtcptAdded
                        }
                        onPressEnter={this.sendMessage}
                        enterButton={
                          this.state.sendingFile ? (
                            <LoadingOutlined />
                          ) : (
                            <SendOutlined />
                          )
                        }
                        onSearch={this.sendMessage}
                        style={{
                          width: "100%",
                        }}
                      />
                    </div>
                  </Col>
                </Row>,
              ]}
            >
              <div
                // className={this.props.is_doctor ? "h-525" : "h-52"}
                className={"h-60"}
                id="message-container"
              >
                {this.state.loading && <Loader />}
                {!this.state.loading && messages.length > 0 ? (
                  messages.map((message, i) => (
                    <div
                      key={message.index}
                      className={
                        message.author === this.props.identity.toString()
                          ? "Cui-box sender"
                          : "Cui-box receiver"
                      }
                      id={`message-list-item-${i}`}
                    >
                      <Avatar
                        size="default"
                        className={
                          message.author === this.props.identity.toString()
                            ? "sender-avatar"
                            : "receiver-avatar"
                        }
                      >
                        {message.author === this.props.identity.toString()
                          ? utils.Capitalize(this.props.localUserName.charAt(0))
                          : utils.Capitalize(
                              this.props.remoteUserName.charAt(0)
                            )}
                      </Avatar>
                      <div
                        className="Cui-message"
                        ref={message.body?.length - 1 && this.messagesEndRef}
                      >
                        {message.type === "media" ? (
                          <MultiMediaMessage message={message} />
                        ) : (
                          <>
                            {message?.attributes?.isLink ? (
                              <LinkMessage message={message.body} />
                            ) : (
                              <span>{message?.body}</span>
                            )}
                          </>
                        )}
                        <div className="msg-time">
                          <span>
                            {utils.FormatDate(
                              utils.ConvertLocalTimeToUserOffset(
                                message.dateCreated,
                                this.props.user_details
                                  ?.time_zone_offset_in_min || ""
                              ),
                              "TIME_1"
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    {/* Here you can chat with your {this.props.is_doctor ? 'Patient' : 'Doctor'} */}
                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    chat_count: state.patientDetailReducer.chat_count,
    user_details: state.loginReducer.user_details,
  };
};
const mapDispatchToProps = {
  chatcount,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoConsultationConversation);
